import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  HeaderListComponent,
  PageListComponent,
} from "../../common/component/Index";
import {
  getPermissionActions,
  genaratePaginateFilterSort,
} from "../../../../helpers/functions";
import DEFINE, { PATHS } from "../../../../constants/Define";
import Ripple from "../../common/component/Ripple";
import { Link } from "react-router-dom";
import InventoryList from "./InventoryList";

const propTypes = {};

let permisionActions = [];
const Inventory = (props) => {
  const { t, match, getListInventory, inventoryReducer } = props;
  const dispatch = useDispatch();
  //! State
  const { isFetching, totalCount, totalPage, pageIndex, pageSize, inventory } =
    inventoryReducer;

  const [params, setParams] = useState({
    pageIndex: pageIndex,
    pageSize: pageSize,
    goodReceiptCode: "",
    materialCode: "",
    materialName: "",
    orderByDesc: true,
  });
  const [permisionActions] = useState(
    getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.WAREHOUSEMANAGEMENT)
  );

  const pagination = {
    totalCount,
    totalPage,
    defaultCurrent: pageIndex,
    pageSize,
  };
  //! Function
  useEffect(() => {
    getListInventory(params);
  }, [params]);

  const onTableChange = (pagination, filters, sorter) => {
    let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
    setParams(newFilters);
    getListInventory(newFilters);
  };
  //! Render
  return (
    <Fragment>
      <PageListComponent>
        <HeaderListComponent
          path={match.path}
          groupPath={"warehousemanagement"}
          titleHeader={t("navigation.warehousemanagement")}
          componentRight={
            <Fragment>
              <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                <Link
                  to={PATHS.WAREHOUSEMANAGEMENT.CREATE.path}
                  className="btn btn-primary"
                >
                  + {t(`action.create`)}
                </Link>
              </Ripple>{" "}
            </Fragment>
          }
        />
        <InventoryList
          loading={!isFetching}
          inventory={inventory}
          pagination={pagination}
          permisions={permisionActions}
          getListInventory={getListInventory}
          params={params}
          onChange={onTableChange}
        />
      </PageListComponent>
    </Fragment>
  );
};

Inventory.propTypes = propTypes;
export default Inventory;
